var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 455",
    style: {
      fill: "none",
      opacity: 0.509
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 142.216a4.219 4.219 0 0 1-.128.9 5.079 5.079 0 0 1-.268.876 3.428 3.428 0 0 1-1.56 1.355 4.739 4.739 0 0 1-3.049.607 5.526 5.526 0 0 1-.735-.16q-.409-.115-.607-.185t-.71-.262q-.511-.192-.626-.23a11.577 11.577 0 0 1-2.237-1.061 21.474 21.474 0 0 1-6.136-6.136 11.578 11.578 0 0 1-1.061-2.237q-.038-.115-.23-.626t-.262-.71q-.07-.2-.185-.607a5.529 5.529 0 0 1-.16-.735 4.739 4.739 0 0 1 .607-3.049 3.428 3.428 0 0 1 1.355-1.56 5.08 5.08 0 0 1 .876-.268 4.219 4.219 0 0 1 .9-.128.716.716 0 0 1 .268.038q.23.077.678.972.141.243.384.69t.447.812q.2.364.4.684.038.051.224.32a3.568 3.568 0 0 1 .275.454.834.834 0 0 1 .09.364 1.061 1.061 0 0 1-.364.639 6.231 6.231 0 0 1-.793.7 7.7 7.7 0 0 0-.793.678.974.974 0 0 0-.364.588.864.864 0 0 0 .064.288 2.788 2.788 0 0 0 .109.262q.045.089.179.307t.147.243a12.67 12.67 0 0 0 5.229 5.229q.026.013.243.147t.307.179a2.791 2.791 0 0 0 .262.109.864.864 0 0 0 .288.064.974.974 0 0 0 .588-.364 7.7 7.7 0 0 0 .678-.793 6.231 6.231 0 0 1 .7-.793 1.061 1.061 0 0 1 .639-.364.834.834 0 0 1 .364.09 3.573 3.573 0 0 1 .454.275q.268.185.32.224.32.192.684.4t.812.447q.447.243.69.384.895.447.972.678a.716.716 0 0 1 .035.265z",
    transform: "translate(-191 -127)",
    style: {
      fill: "#939393"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7dd252cb2d760fb41f937f6c8d0d4ddf.svg";
export { ForwardRef as ReactComponent };